import { MdDevices } from "react-icons/md";

export default function DigitalServices() {
  return (
    <div
      className="p-4 md:p-8_ max-w-6xl w-full mx-auto font-[Tajawal] space-y-8"
      dir="rtl"
    >
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-3 bg-mainLight/10 rounded-2xl text-mainLight shadow-inner">
          <MdDevices size={24} />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
          الخدمات الرقمية
        </h2>
      </div>

      <div className="py-24 text-center bg-gray-100 dark:bg-white/5 rounded-[3rem] border-2 border-dashed border-gray-200 dark:border-white/10">
        <div className="text-6xl font-bold text-mainLight mb-6">SooN</div>
        <h3 className="text-xl font-bold text-gray-400">
          ترقبو هذا القسم قريباً{" "}
        </h3>
      </div>
    </div>
  );
}
